import React from 'react';

import { useTranslation } from 'react-i18next';

import { ROUTES } from '@utils/routes.ts';

import bannerImg from '@assets/images/nomad/n-coins_banner.webp';

import { Button } from '@components/button';

import * as Styled from './n-coins.styled';

const NCoins = () => {
	const { t } = useTranslation('nomad');
	return (
		<Styled.Wrapper>
			<Styled.ImageWrapper>
				<img src={bannerImg} alt='n-coins banner' />
			</Styled.ImageWrapper>
			<Styled.Content>
				<Styled.Title>{t('home_title_2')}</Styled.Title>
				<Styled.Description>{t('home_desc_2')}</Styled.Description>
				<Styled.LinkStyled to={ROUTES.SHOP}>
					<Button color='primary'>{t('home_btn_2')}</Button>
				</Styled.LinkStyled>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default NCoins;
